import { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

export default function LoginPage() {
  const { login } = useAuth();
  const [view, setView] = useState('login'); // 'login' | 'request'
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [reqName, setReqName] = useState('');
  const [reqEmail, setReqEmail] = useState('');
  const [reqPassword, setReqPassword] = useState('');
  const [reqPasswordConfirm, setReqPasswordConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err.response?.data?.error || 'Inloggen mislukt. Probeer het opnieuw.');
    } finally {
      setLoading(false);
    }
  };

  const handleRequest = async (e) => {
    e.preventDefault();
    setError('');
    if (reqPassword.length < 8) {
      return setError('Wachtwoord moet minimaal 8 tekens bevatten.');
    }
    if (reqPassword !== reqPasswordConfirm) {
      return setError('Wachtwoorden komen niet overeen.');
    }
    setLoading(true);
    try {
      await axios.post('/api/auth/request-access', { name: reqName, email: reqEmail, password: reqPassword });
      setSuccess('Je aanvraag is ingediend. Je ontvangt toegang zodra een beheerder je account heeft goedgekeurd.');
    } catch (err) {
      setError(err.response?.data?.error || 'Er is iets misgegaan.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.logoWrap}>
          <div style={styles.logoName}>Lumumba<span style={styles.logoDot}>.</span></div>
          <div style={styles.logoSub}>Commissie Portaal</div>
        </div>

        {/* Tab switcher */}
        <div style={styles.tabs}>
          <button
            style={{ ...styles.tab, ...(view === 'login' ? styles.tabActive : {}) }}
            onClick={() => { setView('login'); setError(''); setSuccess(''); }}
          >
            Inloggen
          </button>
          <button
            style={{ ...styles.tab, ...(view === 'request' ? styles.tabActive : {}) }}
            onClick={() => { setView('request'); setError(''); setSuccess(''); }}
          >
            Toegang aanvragen
          </button>
        </div>

        {view === 'login' && (
          <form onSubmit={handleLogin} style={styles.form}>
            <div style={styles.field}>
              <label style={styles.label}>E-mailadres</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                style={styles.input}
                placeholder="jij@lumumba.nl"
                required
                autoFocus
              />
            </div>
            <div style={styles.field}>
              <label style={styles.label}>Wachtwoord</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                style={styles.input}
                placeholder="••••••••"
                required
              />
            </div>
            {error && <div style={styles.error}>{error}</div>}
            <button
              type="submit"
              style={{ ...styles.btn, opacity: loading ? 0.7 : 1 }}
              disabled={loading}
            >
              {loading ? 'Inloggen...' : 'Inloggen'}
            </button>
          </form>
        )}

        {view === 'request' && (
          <form onSubmit={handleRequest} style={styles.form}>
            {success ? (
              <div style={styles.successMsg}>{success}</div>
            ) : (
              <>
                <div style={styles.field}>
                  <label style={styles.label}>Naam</label>
                  <input
                    type="text"
                    value={reqName}
                    onChange={e => setReqName(e.target.value)}
                    style={styles.input}
                    placeholder="Jouw naam"
                    required
                    autoFocus
                  />
                </div>
                <div style={styles.field}>
                  <label style={styles.label}>E-mailadres</label>
                  <input
                    type="email"
                    value={reqEmail}
                    onChange={e => setReqEmail(e.target.value)}
                    style={styles.input}
                    placeholder="jij@email.com"
                    required
                  />
                </div>
                <div style={styles.field}>
                  <label style={styles.label}>Kies een wachtwoord</label>
                  <input
                    type="password"
                    value={reqPassword}
                    onChange={e => setReqPassword(e.target.value)}
                    style={styles.input}
                    placeholder="Kies een wachtwoord"
                    required
                  />
                </div>
                <div style={styles.field}>
                  <label style={styles.label}>Wachtwoord herhalen</label>
                  <input
                    type="password"
                    value={reqPasswordConfirm}
                    onChange={e => setReqPasswordConfirm(e.target.value)}
                    style={styles.input}
                    placeholder="Herhaal wachtwoord"
                    required
                  />
                </div>
                {error && <div style={styles.error}>{error}</div>}
                <button
                  type="submit"
                  style={{ ...styles.btn, opacity: loading ? 0.7 : 1 }}
                  disabled={loading}
                >
                  {loading ? 'Versturen...' : 'Aanvraag indienen'}
                </button>
              </>
            )}
          </form>
        )}

        <p style={styles.hint}>
          Toegang alleen voor commissieleden.<br />
          Vragen? contact@lumumba.nl
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh', background: '#f0ede8', display: 'flex',
    alignItems: 'center', justifyContent: 'center', padding: '24px',
    fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
  },
  card: {
    background: '#fff', borderRadius: '16px', padding: '48px 40px',
    width: '100%', maxWidth: '400px',
    boxShadow: '0 8px 40px rgba(0,0,0,.08), 0 0 0 1px rgba(0,0,0,.05)',
  },
  logoWrap: { textAlign: 'center', marginBottom: '28px' },
  logoName: {
    fontFamily: 'Georgia, serif', fontSize: '32px',
    fontWeight: 'bold', color: '#1a2a1e', letterSpacing: '-0.5px',
  },
  logoDot: { color: '#3a7a4a' },
  logoSub: {
    fontSize: '12px', color: '#aaa', letterSpacing: '2px',
    textTransform: 'uppercase', marginTop: '6px',
  },
  tabs: {
    display: 'flex', borderBottom: '1px solid #ede9e3', marginBottom: '28px',
  },
  tab: {
    flex: 1, padding: '10px', background: 'none', border: 'none',
    fontSize: '13px', color: '#aaa', cursor: 'pointer', fontFamily: 'inherit',
    borderBottom: '2px solid transparent', marginBottom: '-1px',
  },
  tabActive: { color: '#3a7a4a', borderBottomColor: '#3a7a4a', fontWeight: '600' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  field: { display: 'flex', flexDirection: 'column', gap: '6px' },
  label: { fontSize: '13px', fontWeight: '500', color: '#444' },
  input: {
    padding: '12px 14px', border: '1px solid #e0dcd6', borderRadius: '8px',
    fontSize: '15px', color: '#1a2a1e', background: '#faf8f5',
    outline: 'none', fontFamily: 'inherit',
  },
  error: {
    background: '#fff0f0', border: '1px solid #ffcccc', borderRadius: '8px',
    padding: '12px 14px', fontSize: '14px', color: '#cc0000',
  },
  successMsg: {
    background: '#f0fff4', border: '1px solid #b8e6c4', borderRadius: '8px',
    padding: '16px', fontSize: '14px', color: '#2d6a3f', textAlign: 'center',
    lineHeight: '1.6',
  },
  btn: {
    background: '#3a7a4a', color: '#fff', border: 'none', borderRadius: '8px',
    padding: '14px', fontSize: '15px', fontWeight: '600', cursor: 'pointer',
    marginTop: '4px',
  },
  hint: {
    textAlign: 'center', fontSize: '12px', color: '#bbb',
    marginTop: '28px', lineHeight: '1.6',
  },
};